<template>
  <section class="workshops" id="workshops">
    <div class="container">
      <div class="plaque-title"><h2>Workshops</h2></div>
      <div class="workshops-grid">
        <div v-for="(workshop, index) in workshops" :key="index" class="workshop-card">
          <div class="date">{{ workshop.date }}</div>
          <h3>
            <a v-if="workshop.link" :href="workshop.link" target="_blank" rel="noopener noreferrer">{{ workshop.title }}</a>
            <template v-else>{{ workshop.title }}</template>
          </h3>
          <p class="description">{{ workshop.description }}</p>
          <div class="location">
            <span>{{ workshop.location }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WorkshopsSection',
  data() {
    return {
      workshops: [
        // {
        //   date: 'Coming Soon',
        //   title: 'Project Workshop',
        //   description: 'Discussion of research findings and methodologies in asset pricing with heterogeneous investors.',
        //   location: 'To be announced'
        // },
        {
          date: '19 August 2024',
          title: 'Opening Conference APHIOG',
          link: 'https://cas-nor.no/events/opening-conference-aphiog',
          description: 'Opening conference for the APHIOG project at the Norwegian Academy of Science and Letters.',
          location: 'The Norwegian Academy of Science and Letters, Oslo'
        },
        {
          date: 'June 10, 2025',
          title: 'APHIOG closing conference',
          link: 'https://cas-nor.no/events/aphiog-closing-conference',
          description: 'Closing conference for the APHIOG project.',
          location: 'The Norwegian Academy of Science and Letters, Oslo'
        }
      ]
    }
  }
}
</script>

<style scoped>
.workshops {
  padding: 4rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.plaque-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
}
.plaque-title h2 {
  background: rgba(255,255,255,0.85);
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  border-radius: 16px;
  padding: 1rem 2.5rem;
  font-size: 2.5rem;
  color: #1a1a1a;
  backdrop-filter: blur(6px);
  margin: 0;
}

.workshops-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.workshop-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  position: relative;
}

.workshop-card:hover {
  transform: translateY(-5px);
}

.date {
  display: inline-block;
  background-color: #2c3e50;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  font-weight: 500;
}

h3 {
  font-size: 1.5rem;
  color: #1a1a1a;
  margin-bottom: 1rem;
}

.description {
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.location {
  color: #666;
  font-style: italic;
}

@media (max-width: 768px) {
  .workshops-grid {
    grid-template-columns: 1fr;
  }
  
  .workshop-card {
    padding: 1.5rem;
  }
}
</style>
